// extracted by mini-css-extract-plugin
module.exports = {"garderobo":"ScreenTotalLook_garderobo__CaKgs"};